import { types } from '../actions/commentActions';
import initialState from './initialState';

export default function commentReducer(state = initialState.commentReducer, action) {
  switch (action.type) {
    case types.COMMENTS_LOADING_START: {
      return { ...state, isLoading: true };
    }
    case types.COMMENTS_LOADED_SUCCESSFULLY: {
      action.comments
        .sort((c1, c2) => c2.createdOn.localeCompare(c1.createdOn))
        .forEach((comment) => {
          // eslint-disable-next-line no-param-reassign
          comment.assets = JSON.parse(comment.assets);
          // eslint-disable-next-line no-param-reassign
          comment.users = JSON.parse(comment.users);
        });
      return { ...state, isLoading: false, comments: action.comments };
    }
    case types.COMMENTS_LOADED_FAILED: {
      return { ...state, isLoading: false, comments: [] };
    }
    case types.ADDING_COMMENT: {
      return { ...state, addCommentLoading: true };
    }
    case types.UPSERT_COMMENT: {
      const { comment } = action;
      return {
        ...state,
        comments: [comment, ...state.comments.filter((c) => c.id !== comment.id)],
        addCommentLoading: false,
      };
    }
    case types.COMMENT_ADDING_FAILED: {
      return { ...state, addCommentLoading: false };
    }
    case types.SET_TASK_ID_FOR_COMMENTS: {
      return { ...state, taskIdForComments: action.taskId };
    }
    case types.DELETE_COMMENT: {
      const { comment } = action;
      return {
        ...state,
        comments: [...state.comments.filter((c) => c.id !== comment.id)],
      };
    }
    default:
      return state;
  }
}
